import { Component,Input, ViewChild,EventEmitter, ViewContainerRef,
       Output, OnInit, ElementRef,ChangeDetectorRef} from '@angular/core';
import { DragulaService } from 'ng2-dragula';
import Util from '../../helpers/Util';
import Utils from '../../helpers/Util';
import { ShareService } from '../../commonservices/shared.service';
@Component({
    selector: 'app-rule-properties',
    styleUrls: ['ruleproperties.scss'],
    templateUrl: 'ruleproperties.component.html'
  })
  
  export class RulePropertiesComponent implements OnInit { 
    @ViewChild('editableStyle', {static: false}) editableStyle: ElementRef;
    @ViewChild('isCheck', {static: false}) isCheck: ElementRef;
    @Output() appliedSaveEvent = new EventEmitter();
    @Output() propertiesSaveEvent = new EventEmitter(); 
    @Output() dropDownListPropEvent = new EventEmitter();
    @Output() onSearch = new EventEmitter();
    @Output() onFetch = new EventEmitter();
    @ViewChild('container',  {static: true,read: ViewContainerRef}) container: ViewContainerRef;
    @Input() ruleLeft: any;
    @Input() ruleRight: any;
    @Input() desc: any;
    
    isDisabled:boolean = true;
    public selectedRightRule = {Id:0,  Name:"",  Description:"", RuleProperty:[]};
    public decimals: number = 3;
    seperator:any = []
    divId = 0;
    tempSelectedRightRule:any;
    mdi: string;
    tempselectedRightRuleStore:any;
    constructor(private _dragulaService:DragulaService,
                private changeDetectorRefs: ChangeDetectorRef,
                private _sharedService: ShareService) { 
                this._sharedService.changeEmitted$.subscribe((data) => { })
    }

    ngOnInit(): void {   
      this.preventDragging();
    }  

    ngAfterViewInit(){
      this.preventDragging();
    }

    preventDragging() {
      this._dragulaService.createGroup("VAMPIRES", {
        copy: (el, source) => {
          return source.id === 'left';
        },
        copyItem: (rule) => {
          var tempRule = Util.DeepCopy(rule);
          return tempRule;
        },
        accepts: (el, target, source, sibling) => {
          return target.id !== 'left';
        }
      });
    }

    dbClick(data){
      data.IsDisabled = false;
      data.Style = "text-click";
      this.mdi = '<i style="font-weight: 900;color: #406540;" class="mdi mdi-check-circle"></>';
      this.isCheck.nativeElement.innerHTML  = this.mdi;
    }
    isEditable(data){
      data.IsDisabled = false;
      data.Style = "text-click";
      this.mdi = '<i style="font-weight: 900;color: #406540;" class="mdi mdi-check-circle"></>';
      this.isCheck.nativeElement.innerHTML  = this.mdi;
    }

    onEnter(data){
      data.IsDisabled = true;
      data.Style = "text-default";
    }

    selectedRight(data){
      this.selectedRightRule = data;
    
      var scope = this; var resetCtr = 3;
      this.divId = 0;
      this.selectedRightRule.RuleProperty.forEach(function(item,index) {
        if(index === resetCtr){
          resetCtr+=3;
          scope.divId+=1;  //assign div id
        }
        if(index < resetCtr){
          item.divId = scope.divId;
        }
      });
      this.initSeperator(scope.divId);
      this.selectedRightRule.RuleProperty.forEach(item => { 
        if(item.Type === 'select' || item.Type === 'combobox' || item.Type === 'grid' || item.Type === 'multiselect' || item.Type === 'multiselect2'){
          item.Store = JSON.parse(item.Store);
        }
      });
      this.tempSelectedRightRule = Utils.DeepCopy(this.selectedRightRule);
      this._sharedService.emitChange(this.selectedRightRule);
    }

    selectedLeft(data) { }

    appliedSave(){
      var tempRuleRight = Utils.DeepCopy(this.ruleRight);
      tempRuleRight.forEach((item) => {
        item.RuleProperty.forEach( (itemProp) =>{
          if(itemProp.Store != null){
            itemProp.Store = JSON.stringify(itemProp.Store);  
          }
       });
      });
      this.appliedSaveEvent.emit(tempRuleRight);
    }
    
    saveProperties() { 
      var tempRuleRight = Utils.DeepCopy(this.ruleRight);
      tempRuleRight.forEach((item) =>{
        item.RuleProperty.forEach( (itemProp) =>{
          itemProp.Store  = JSON.stringify(itemProp.Store)
       });
      });
      this.propertiesSaveEvent.emit(tempRuleRight)
    }

    initSeperator(lastDivId){
      this.seperator = [];
      for(var i = 0; i<=lastDivId;i++){
        this.seperator.push(i);
      }
    }
    addProperties(){
      var lastDivId = this.selectedRightRule.RuleProperty[this.selectedRightRule.RuleProperty.length-1].divId; //get the last div Id
      if(lastDivId > 0){
        this.divId = lastDivId;
        this.initSeperator(lastDivId);
      }else{
        this.divId = 0
      }
      this.divId = this.divId + 1;
      this.seperator.push(this.divId);
      var scope = this;
      this.tempSelectedRightRule.RuleProperty.forEach(function(item,index) {
        if(index < 3){//copy only the first three
          var temp = Utils.DeepCopy(item);
          if(index==2){ //assign to empty as default value
            temp.Value = "";
          }
          temp.divId = scope.divId;
          scope.selectedRightRule.RuleProperty.push(temp);
        }
      });
    }

    close(divId){
      this.selectedRightRule.RuleProperty = this.selectedRightRule.RuleProperty.filter(item => item.divId != divId);
      this.seperator = this.seperator.filter(item=>item != divId);
    }

    onChange(newValue,divId)//div will determine of what number of div
    {
      var temp = {"value":newValue,"divId":divId}
      this.dropDownListPropEvent.emit(temp)
      this._sharedService.emitChange(this.selectedRightRule);
      this.changeDetectorRefs.detectChanges();
    }

    execKeypress(event:any,field:string) {
      var temp = {"field":field,"term":event.term}
      this.onSearch.emit(temp);
    }
    fetchMore(){
       this.onFetch.emit();
   }
  }
